import { DateTime, IANAZone } from "luxon";

import CalendarScheduleDay from "./CalendarScheduleDay";
import CalendarServiceSchedule from "./CalendarServiceSchedule";
import CalendarSlotStatus from "./CalendarSlotStatus";
import ICalendar, { ICalendarSchedule, ICalendarServiceSchedule, ScheduleSlot } from "./ICalendar";
import { ICalendarResponse } from "./ICalendarResponse";

const buildIsoDateTime = (dateIso: string, timeIso: string, zone: IANAZone) =>
  DateTime.fromISO(`${dateIso}T${timeIso}`, { zone });

/** An implementation of {@link ICalendar} constructed from the calendar API response. */
class Calendar implements ICalendar {
  readonly schedules: ICalendarServiceSchedule[];

  constructor(calendarResponse: ICalendarResponse, centerTimeZone: IANAZone) {
    this.schedules = calendarResponse.schedules.map(schedule => {
      const formattedDays: ICalendarSchedule = {};
      for (const [date, slots] of Object.entries(schedule.days))
        formattedDays[date] = new CalendarScheduleDay(
          (slots ?? []).map(
            slot =>
              new ScheduleSlot(
                slot.id,
                buildIsoDateTime(date, slot.startTime, centerTimeZone).toUTC().toISO(),
                buildIsoDateTime(date, slot.endTime, centerTimeZone).toUTC().toISO(),
                slot.type !== CalendarSlotStatus.Open,
                centerTimeZone
              )
          )
        );
      return new CalendarServiceSchedule(schedule.service, formattedDays, centerTimeZone);
    });
  }
}

export default Calendar;
